import { createTitleTimeline } from '../animations'
import utils from '../utils'
import appUtils from '../app_utils'

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const dataAttrSuffix = 'section-product'
const dataAttr = 'data-' + dataAttrSuffix

const STAGGER_OFFSET = 0.3

const getFromX = function(item) {
  return (' ' + item.className + ' ').indexOf(' even ') > -1 ? 50 : -50
}

class SectionProduct {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.tl = null

    this.titleTimeline = null
    this.$title = this.$el.find('[data-section-title]')

    this.$content = this.$el.find('[' + dataAttr + '-content]')
    // this.$items = this.$el.find('[' + dataAttr + '-item]')
    this.items = document.querySelectorAll('[' + dataAttr + '-item]')

    this.timelineArray = []

    this.id = dataAttrSuffix + '-' + args.index
    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.$el.attr('id', this.id)
    }
    this.init()
  }

  init() {
    /*
    gsap.utils.toArray(this.$items).forEach((item, i) => {
      // gsap.set(item, {opacity: 0, x: getFromX(item)}) // set
      // gsap.set(item, {opacity: 0, y: 50}) // set
    })
    */

    this.items.forEach((item, i) => {
      this.timelineArray.push(this.addTimeline(item, i))
    })

    this.titleTimeline = createTitleTimeline(this.$title, true)
  }

  addTimeline(item, index) {
    const image = item.querySelector('[data-img]');
    const imageDetail = item.querySelector('[data-img-detail]');
    const caption = item.querySelector('[data-caption]');
    const title = item.querySelector('[data-title]');
    const text = item.querySelector('[data-text]');

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "top 70%",
        ease: "power2",
        toggleActions: "play none none reverse"
      }
    })
    .call(()=>{
      image.classList.add('in-view-once')
    }, [], '-=0')
    .from(title, {
      y: 50,
      opacity: 0,
      duration: 0.5
    }, '+=0.2')
    .from(text, {
      opacity: 0,
      duration: 0.5,
    }, '-=0.1')
    .call(()=>{
      imageDetail.classList.add('show')
    }, [], '-=0.2')
    .from(caption, {
      opacity: 0,
      duration: 0.5,
    }, "+=0.4")

    return timeline
  }

  destroy() {
    /*
    Kills the ScrollTrigger instance, immediately unpinning and restoring any pin-related changes made to the DOM by ScrollTrigger and removing all scroll-related listeners, etc. so that the instance is eligible for garbage collection.
    */

    if (this.timelineArray.length) {
      this.timelineArray.forEach(tl => {
        tl.scrollTrigger.kill()
        tl.kill()
      })
    }

    if (this.tl) {
      this.tl.scrollTrigger.kill()
      this.tl.kill()
    }

    if (this.titleTimeline) {
      this.titleTimeline.scrollTrigger.kill()
      this.titleTimeline.kill()
    }
  }
}

export default {dataAttr: dataAttr, sectionClass: SectionProduct}
